import Tip from './src/tip.vue';
import { SFCWithInstall } from '@touchvue/utils';
declare const ToTip: SFCWithInstall<typeof Tip>;
export * from './src/instance';
interface TipOptions {
    icon?: string;
    content?: string;
    color?: string;
    opDisplay?: string;
    mode?: string;
    position?: string;
    during?: string | number;
    closable?: boolean;
    deletable?: boolean;
    showIcon?: boolean;
    className?: string;
    [key: string]: any;
}
export declare const $tip: {
    (options: TipOptions | string): Promise<boolean>;
    success(options: TipOptions | string): Promise<boolean>;
    error(options: TipOptions | string): Promise<boolean>;
    info(options: TipOptions | string): Promise<boolean>;
    warning(options: TipOptions | string): Promise<boolean>;
    danger(options: TipOptions | string): Promise<boolean>;
    fg(options: TipOptions | string): Promise<boolean>;
    toast(options: TipOptions | string): Promise<boolean>;
};
export default $tip;
export { ToTip };
